import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setDocumentControlPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useDocumentControlSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getDocumentControlSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.document_control_page?.document_control_section}`);
      console.log("🚀 ~ getDocumentControlSectionJson ~ data:", response);
      console.log("🚀 ~ getDocumentControlSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setDocumentControlPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Document Control section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getDocumentControlSectionJson();
  }, [getDocumentControlSectionJson]);

  return {
    data,
    loading,
    error,
    getDocumentControlSectionJson,
    fetchOnMount,
    refetch: getDocumentControlSectionJson
  };
};

export default useDocumentControlSection;
